import { COMPONENT_TYPES } from '../../../constants';
import SignupComponent from './Signup.component';
import SignupEditor from './Signup.editor';
import SignupProperties from './Signup.properties';
import { registerComponent } from '../registry';

// 레지스트리에 Signup 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.SIGNUP,
  component: SignupComponent,
  editorComponent: SignupEditor,
  properties: SignupProperties,
  defaultProps: {
    varFields: {
      var01: { 
        show: false, 
        label: "", 
        type: "input", 
        options: [], 
        required: false,
        content: ""
      },
      var02: { 
        show: false, 
        label: "", 
        type: "input", 
        options: [], 
        required: false,
        content: ""
      },
      var03: { 
        show: false, 
        label: "", 
        type: "input", 
        options: [], 
        required: false,      
        content: ""
      }
    },
    basicFields: {
      userId: true,
      password: true,
      name: true,
      phone: true,
      email: true,
      birthday: true,
      address: true,
      referralCode: true
    },
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      maxWidth: '800px',
      margin: '0 auto',
      marginTop: '20px',
      marginBottom: '20px'
    }
  },
  category: 'form',
  icon: '📝',
  name: '회원가입'
});

// 컴포넌트 및 타입 내보내기
export { default as SignupComponent } from './Signup.component';
export { default as SignupEditor } from './Signup.editor';
export { default as SignupProperties } from './Signup.properties';
export * from './Signup.types'; 